import { useRef, memo, FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import SearchFormDesktopMui from 'screens/CoverLetterScreen/desktop/components/SeachForm/Mui/SearchFormDesktopMui'
import SearchFormMobileMui from 'screens/CoverLetterScreen/mobile/components/SearchForm/Mui/SearchFormMobileMui'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%',
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #bbbbbb',
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      marginBottom: 10,
      backgroundColor: '#fff',
      borderBottom: '1px solid #e8e8e8',
      zIndex: 0,
    },
  },
  searchButton: {
    backgroundColor: theme.palette.primary.main,
    paddingTop: 7.5,
    paddingBottom: 7.5,
    width: 62,
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 5px)',
    },
  },
  inputBorder: {
    border: '1px solid #ccc',
  },
  searchFormRoot: {
    margin: '0 auto',
    maxWidth: '883px',
    minHeight: 'auto',
  },
  input: {
    paddingTop: 9,
    paddingBottom: 9,
  },
}))

interface CoverLetterItemSearchBoxProps {
  coverLetterId?: string
}
const CoverLetterItemSearchBox: FC<CoverLetterItemSearchBoxProps> = ({
  coverLetterId,
}) => {
  const classes = useStyles()
  const rootRef = useRef<HTMLDivElement>(null)
  const isMobile = useIsMobile()

  return (
    <div className={classes.root} ref={rootRef}>
      {isMobile ? (
        <SearchFormMobileMui
          submitButtonID="gtm-search2-button-coverletter"
          coverLetterId={coverLetterId}
          renderRecommendSearchKeyword={false}
          rootProps={{ className: classes.searchFormRoot }}
          SubmitButtonProps={{ className: classes.searchButton }}
          InputProps={{
            className: classes.inputBorder,
            inputProps: { className: classes.input },
          }}
        />
      ) : (
        <SearchFormDesktopMui
          submitButtonID="gtm-search2-button-coverletter"
          coverLetterId={coverLetterId}
          renderRecommendSearchKeyword={false}
          rootProps={{ className: classes.searchFormRoot }}
          SubmitButtonProps={{ className: classes.searchButton }}
          InputProps={{
            className: classes.inputBorder,
            inputProps: { className: classes.input },
          }}
        />
      )}
    </div>
  )
}

export default memo(CoverLetterItemSearchBox, (prevProps, nextProps) => {
  return prevProps?.coverLetterId === nextProps?.coverLetterId
})
